import moment from 'moment';
import React, { useEffect, useState } from 'react';
import GlobalStore from '../../stores/global-store';
import payoutsApi from '../../apis/payouts-api';
import FilterDate from '../../components/FilterDate/FilterDate';

function Payout() {
  const {setLoading, affID} = GlobalStore.useContainer();
  const [dataPayout, setDataPayout] = useState([]);
  const [dataPayoutFiltered, setDataPayoutFiltered] = useState([]);

  useEffect(() => {
    async function getPayoutsData() {
      setLoading(true);
      const responseDashboard = await payoutsApi.getPayouts(affID);
      setDataPayout(responseDashboard?.data?.payouts);
      setDataPayoutFiltered(responseDashboard?.data?.payouts);
      setLoading(false);
    }

    getPayoutsData();
  }, [setLoading]);

  const payoutsFilterHandler = (dateEntry) => {
    let payoutFilterTmp = [];

    if (dateEntry.slug !== 'all') {
      const dateRange = {
        startDate: dateEntry.range.startDate,
        endDate: dateEntry.range.endDate
      };
      payoutFilterTmp = dataPayout.filter(row => {
        return filterRangeDate(dateRange, row.order_date);
      });
      setDataPayoutFiltered(payoutFilterTmp);
    } else {
      setDataPayoutFiltered(dataPayout);
    }
  };

  const filterRangeDate = (dateRange, entryDate) => {
    let filterPass = true;
    const date = moment(entryDate).unix();
    if (dateRange.startDate) {
      filterPass = filterPass && (dateRange.startDate <= date);
    }
    if (dateRange.endDate) {
      filterPass = filterPass && (dateRange.endDate >= date);
    }
    return filterPass;
  };

  return (
    <div className="page-home container-fluid">
      <div className="d-flex justify-content-between align-items-baseline mb-3">
        <h2>Thanh toán</h2>
        <FilterDate onSelectDate={payoutsFilterHandler} />
      </div>

      <hr className="mb-5" />

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Ngày mua hàng</th>
              <th>Giá trị đơn hàng</th>
              <th>Hình thức thanh toán</th>
              <th>Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            { dataPayoutFiltered?.length > 0 && (
              dataPayoutFiltered.map((item, index) => (
                <tr key={index}>
                  <td>{moment(item.order_date).format('DD/MM/YYYY')}</td>
                  <td>{item.amount ? item.amount.toLocaleString() : ''}</td>
                  <td>{item.payout_method}</td>
                  <td><span className={
                    item.status === 'Paid' ? 'badge badge-success' : (item.status === 'Unpaid' ? 'badge badge-danger' : '')
                  }>{item.status}</span></td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Payout;
